<template>
  <div data-cy="phone-fields">
    <div class="font-bold">Primary Phone</div>
    <PhoneField
      v-model="primaryPhone"
      primary
      :name="getName(primaryPhone)"
      :can-delete="false"
      @set-primary="setPrimary($event)"
    />
    <div v-if="additionalPhones.length" class="font-bold">
      Additional Phone(s)
    </div>
    <div ref="fieldsContainer" class="scrollable-fields-container mb-3">
      <div v-for="(phone, i) in additionalPhones" :key="phone.id">
        <PhoneField
          :key="phone.id"
          :model-value="additionalPhones[i]"
          :primary="phone.primary"
          :name="getName(phone)"
          :can-delete="formData.phones.length > 1"
          @update:model-value="handlePhoneUpdate($event, phone.id)"
          @delete-phone="handleDelete($event, i)"
          @set-primary="setPrimary($event)"
        />
      </div>
    </div>
    <div class="icon-margin-right-2x">
      <ItemAdder
        text="Add Phone"
        class="mt-2"
        slim
        transparent
        data-cy="add-phone"
        @click="addPhone"
      />
    </div>
  </div>
</template>

<script>
import { nextTick } from "vue";
import { generateUID } from "@/lib/helpers.js";

import ItemAdder from "@/components/ItemAdder.vue";
import PhoneField from "@/Customer/PhoneField.vue";
import useVuelidate from "@vuelidate/core";

export default {
  components: {
    PhoneField,
    ItemAdder
  },
  props: {
    formData: {
      type: Object,
      default: () => ({})
    }
  },
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  computed: {
    primaryPhone: {
      get() {
        return this.formData.phones.find((phone) => phone.primary);
      },
      set(value) {
        // eslint-disable-next-line vue/no-mutating-props
        this.formData.phones = this.formData.phones.map((phone) => {
          if (phone.id === value.id) {
            return { ...value };
          }

          return phone;
        });
      }
    },
    additionalPhones() {
      return this.formData.phones.filter((phone) => !phone.primary);
    }
  },
  created() {
    if (!this.formData.phones.length) {
      this.addPhone(true);
    }
  },
  methods: {
    addPhone(primary = false) {
      // eslint-disable-next-line vue/no-mutating-props
      this.formData.phones = [
        ...this.formData.phones,
        {
          id: generateUID(),
          new: true,
          phone_number: "",
          type: "",
          primary: primary,
          label: ""
        }
      ];

      nextTick(() => {
        this.$refs.fieldsContainer.scrollTop =
          this.$refs.fieldsContainer.scrollHeight;
      });
    },
    getName(phone) {
      return phone.primary ? "Phone (Primary)" : `${phone.id}-phone`;
    },
    handleDelete(phone) {
      // eslint-disable-next-line vue/no-mutating-props
      this.formData.phones = this.formData.phones.filter(
        (altPhone) => phone.id !== altPhone.id
      );
    },
    setPrimary(phoneData) {
      // eslint-disable-next-line vue/no-mutating-props
      this.formData.phones = this.formData.phones.map((phone) => ({
        ...phone,
        primary: phone.id === phoneData.id
      }));
    },
    handlePhoneUpdate(value) {
      // eslint-disable-next-line vue/no-mutating-props
      this.formData.phones = this.formData.phones.map((phone) => {
        if (phone.id === value.id) {
          return { ...value };
        }

        return phone;
      });
    }
  }
};
</script>
